import React, { useState } from 'react'
import { StandaloneSearchBox } from '@react-google-maps/api'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'

import Icon from 'components/Icon'
import Button from 'components/UI/Button'

const MapsSearchBox = ({ t, onPlaceSelect, bounds }) => {
    const [searchBox, setSearchBox] = useState(null)
    const [query, setQuery] = useState('')

    const handleOnChange = (e) => {
        setQuery(e.target.value)
    }

    const handleClearClick = () => {
        setQuery('')
    }

    return (
        <div className="maps-search-box">
            <StandaloneSearchBox
                bounds={bounds}
                onLoad={searchBox => setSearchBox(searchBox)}
                onPlacesChanged={() => {
                    const places = searchBox.getPlaces()

                    if (places && places.length) {
                        const place = places[0]
                        onPlaceSelect(place)
                    }
                }}
            >
                <div className="maps-search-box__input-container">
                    <input
                        type="text"
                        placeholder={t('maps:findPlaceOrLocation')}
                        onChange={handleOnChange}
                        value={query}
                    />
                    {query ? (
                        <div className="maps-search-box__input-action">
                            <Button
                                onClick={handleClearClick}
                                trackName="clearSearchBox"
                            >
                                <Icon fa name="times" color="gray" />
                            </Button>
                        </div>
                    ) : (
                        <div className="maps-search-box__input-icon">
                            <Icon fa name="search" color="gray" />
                        </div>
                    )}
                </div>
            </StandaloneSearchBox>
        </div>
    )
}

MapsSearchBox.propTypes = {
    onPlaceSelect: PropTypes.func,
    bounds: PropTypes.object,
}

export default withTranslationCustom('maps')(MapsSearchBox)
